import '../App.css';
import { useState, useEffect } from 'react';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);

  const logos = [
    '/LOGO_ALICE-01.png',
    '/LOGO_ALICE-02.png',
    '/LOGO_ALICE-03.png',
    '/LOGO_ALICE-05.png',
    '/LOGO_ALICE-06.png',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLogoIndex((prevIndex) => (prevIndex + 1) % logos.length);
    }, 1000);

    return () => clearInterval(interval); // Pulisce l'intervallo quando il componente viene smontato
  }, [logos.length]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="shadow-md p-2 px-5 flex justify-between md:justify-start items-center sticky top-0 z-50 bg-white lg:shadow-none border-black border-b-2">
      <a href="https://silabor.dingegno.com">
        <img src={logos[currentLogoIndex]} width={'150rem'} alt="Logo" />
      </a>
      <button onClick={toggleMenu} className="lg:hidden">
        <i className="fas fa-bars w-8 h-8"></i>
      </button>
      <nav
        className={`fixed top-0 left-0 h-full bg-white transform ${
          menuOpen ? 'translate-x-0' : '-translate-x-[120%]'
        } transition-transform lg:relative lg:translate-x-0 lg:flex lg:space-x-3 lg:ml-5 shadow-lg lg:shadow-none lg:bg-transparent py-10 px-6 lg:px-0 lg:py-0`}
      >
        <a
          href="https://silabor.dingegno.com"
          className="block text-base text-sm uppercase font-semibold text-[#000000] py-1 px-1 rounded-none flex items-center hover:underline hover:underline-offset-4 hover:decoration-2"
        >
          <i className="fas fa-home mr-2"></i>
          Home
        </a>
        <a
          href="https://orientamento.dingegno.com"
          className="block text-base text-sm uppercase font-semibold text-[#000000] py-1 px-1 rounded-none flex items-center hover:underline hover:underline-offset-4 hover:decoration-2"
        >
          <i className="fas fa-crosshairs mr-2"></i>
          Orientamento
        </a>
        <a
          href="https://labs.dingegno.com"
          className="block text-base text-sm uppercase font-semibold text-[#000000] py-1 px-1 rounded-none flex items-center hover:underline hover:underline-offset-4 hover:decoration-2"
        >
          <i className="fas fa-flask mr-2"></i>
          Laboratori
        </a>
      </nav>
    </header>
  );
}

export default Navbar;